<script setup lang="ts">
import { onError, onHide, onLaunch, onShow, onUnhandledRejection } from '@dcloudio/uni-app'

/** 微信小程序版本热更新 */
function checkMiniProgramUpdate() {























}
onLaunch(() => {
  console.log('App Launch')
  checkMiniProgramUpdate()
  // TODO: 应用启动初始化（全局配置、城市、用户态等），业务重建时在此补充
})
onShow(() => {
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
onError((msg) => {
  console.log('App Error', msg)
})
onUnhandledRejection((err) => {
  console.log('App UnhandledRejection', err)
})
</script>

<style lang="scss">
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
